import React from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import ImageUpload, {
  UploadAspectRatios
} from 'legacy/common/components/wysiwyg-form/ImageUpload';
import { useImageUploadCommand } from 'legacy/common/hooks/useImageUploadCommand';
import CenteredContainer from 'components/CenteredContainer';
import BlurredBackgroundSection from 'components/BlurredBackgroundSection';

import { useOrganization } from '../../../../context/EditOrganizationProvider';
import { EditOrganizationFormValues } from '../../../../types/edit-organization';
import EditOrgDesktopSkeleton from '../EditOrgDesktopSkeleton';
import BadgeAndName from '../BadgeAndName';
import Location from '../Location';
import Description from '../Description';

const DesktopForm = ({ uploadImage }) => {
  const { t } = useTranslation(['organizations']);
  const { values, touched, errors } =
    useFormikContext<EditOrganizationFormValues>();
  const uploadImageCommand = useImageUploadCommand();
  const { data } = useOrganization();

  if (data.isLoadingOrganization) {
    return <EditOrgDesktopSkeleton />;
  }

  return (
    <BlurredBackgroundSection
      imageUrl={values.coverImage}
      backgroundContent={
        values.coverImage ? null : (
          <div className="bg-neutral-400 flex w-full justify-center items-center">
            <span className="text-[300px]">🖼</span>
          </div>
        )
      }
    >
      <CenteredContainer>
        <div className="flex md:pt-12 pb-36 flex-col md:flex-row">
          <div className="flex-1 relative">
            <ImageUpload
              photoUrl={values.coverImage}
              className="mx-auto md:w-[318px]"
              isUploading={uploadImageCommand.isLoading}
              aspectRatio={UploadAspectRatios.NineToSixteen}
              defaultIconSize={100}
              label={t('form.coverImageLabel')}
              maxLabel={t('form.coverImageMax')}
              onUploadPhoto={uploadImage('coverImage')}
              error={(touched.coverImage && errors.coverImage) || ''}
              disabled={data.isSubmitting}
            />
          </div>
          <div className="flex-1 flex items-center flex-col justify-center">
            <BadgeAndName uploadImage={uploadImage} />
            <Location />
            <Description />
          </div>
        </div>
      </CenteredContainer>
    </BlurredBackgroundSection>
  );
};

export default DesktopForm;
